import { combineReducers } from 'redux';

import auth from './auth';
import lic_state from '../state/lic_state';

export default combineReducers({
    auth, lic_state
});



// WEBPACK FOOTER //
// ./src/modules/index.js